import { render, staticRenderFns } from "./equ-mior.vue?vue&type=template&id=28f54cb3&scoped=true&"
import script from "./equ-mior.vue?vue&type=script&lang=js&"
export * from "./equ-mior.vue?vue&type=script&lang=js&"
import style0 from "./equ-mior.vue?vue&type=style&index=0&id=28f54cb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f54cb3",
  null
  
)

export default component.exports